import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';


export default class NextButton extends React.Component {

  render() {
    const { next, loading, onTouchTap, style } = this.props;
    if (!next) {
      return null;
    }
    return (
      <RaisedButton
        style={style}
        label={loading ? 'Loading ...' : 'Load More'}
        primary={true}
        disabled={loading}
        onTouchTap={(e) => {
          if (onTouchTap) {
            onTouchTap(e);
          }
        }}
      />
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/NextButton.jsx